import script from "./app-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./app-form.vue?vue&type=script&lang=ts&setup=true"

import "./app-form.vue?vue&type=style&index=0&id=6a0f7e7b&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0f7e7b"]])

export default __exports__